/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ErrataInputs */



/**
* | output |
* | --- |
* | "Errata" |
*
* @param {Nav_ErrataInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_errata = /** @type {((inputs?: Nav_ErrataInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ErrataInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Errata")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Errata")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("勘误")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("勘誤")
	if (locale === "ko") return /** @type {LocalizedString} */ ("에라타")
	return /** @type {LocalizedString} */ ("Errata")
});